// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-7a592b8e] {\n  text-align: left;\n  margin-left: 50px;\n  margin-bottom: 35px;\n}\n[data-v-7a592b8e] .el-form-item {\n  text-align: left;\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
